import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '../..'
import feedStore from '../feed-store'
import statementStore from '../../statement/statement-store'

export default async function viewStatements(context: BareActionContext<FeedState, RootState>)
{
    feedStore.commitSetFeedType({ type: 'statement-feed', columns: 2 })
    statementStore.dispatchSetStatementQuery()

    return
}
